import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedNumber from 'I18n/components/FormattedNumber';
import UIFlex from 'UIComponents/layout/UIFlex';
import { useSelector } from 'react-redux';
import { AllProductLines } from 'self-service-api/constants/ProductLines';
import { ProductLevelAndProductLineToSuiteBOTranslationKeyMap } from '../../../constants/BusinessObjectivesTranslationKeys';
import { useAppSelector } from '../../../reducers';
import { currentSkuIdForProductSelector, productSelector, productVersionSelector } from '../../../selectors/ProductsSelectors';
import { jsx as _jsx } from "react/jsx-runtime";
const SuiteBusinessObjectivesSubtext = ({
  productLevel,
  productLine
}) => {
  const product = useSelector(state => AllProductLines.includes(productLine) ? productSelector(state, {
    productLine: productLine,
    productLevel
  }) : null);
  const skuId = useAppSelector(state => product ? currentSkuIdForProductSelector(state, {
    productId: product.id
  }) : null);
  const quantityPackDetails = useAppSelector(state => skuId ? productVersionSelector(state, {
    skuId
  }).quantityPackDetails : []);
  const quantityPack = quantityPackDetails[0];
  if (!quantityPack) return null;
  const includedWithProductVersion = quantityPack && quantityPack.quantityUnit && quantityPack.quantityUnit.includedWithProductVersion;
  const messageTranslation = ProductLevelAndProductLineToSuiteBOTranslationKeyMap[productLevel][productLine]['subtext'];
  if (!messageTranslation) return null;
  return /*#__PURE__*/_jsx(UIFlex, {
    direction: "column",
    children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: messageTranslation,
      elements: {
        IncludedAdditionalUnits: () => /*#__PURE__*/_jsx(FormattedNumber, {
          value: includedWithProductVersion
        })
      }
    })
  });
};
export default SuiteBusinessObjectivesSubtext;